import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http'
import { inject } from '@angular/core'
import { from, switchMap, throwError } from 'rxjs'
import { environment } from '../../environments/environment'
import { PosthogService } from '../shared/services/posthog.service'
import { demoSession } from './demo-session'

/**
 * Outermost: no demo API call reaches auth, offline queues, service-worker API cache, or the network.
 * Only this shell is in the main bundle; the demo's API (`./backend`) loads on the first demo request.
 */
export const demoInterceptor: HttpInterceptorFn = (req, next) => {
  const session = demoSession()
  if (!session) return next(req)
  const url = new URL(req.url, window.location.origin)
  const base = new URL(environment.baseUrl, window.location.origin)
  const isApi = url.origin === base.origin && (url.pathname === base.pathname || url.pathname.startsWith(base.pathname.replace(/\/$/, '') + '/'))
  if (!isApi) {
    // Only bundled static assets/translations pass through; JWT must never be added to them.
    if (url.origin === window.location.origin && /\/(assets|i18n)\//.test(url.pathname) && req.method === 'GET') return next(req)
    return throwError(() => new HttpErrorResponse({ status: 403, error: { message: 'External requests are disabled in demo mode' } }))
  }
  const path = url.pathname.slice(base.pathname.replace(/\/$/, '').length) || '/'
  const analytics = inject(PosthogService)
  return from(import('./backend')).pipe(switchMap(({ handle }) => handle(req, path, session, analytics)))
}
